import { render } from "./DebugDesigns.vue?vue&type=template&id=412ad131&scoped=true"
import script from "./DebugDesigns.vue?vue&type=script&lang=js"
export * from "./DebugDesigns.vue?vue&type=script&lang=js"

import "./DebugDesigns.vue?vue&type=style&index=0&id=412ad131&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412ad131"]])

export default __exports__